module.exports = __webpack_public_path__ + "img/hz_16.dc35466e.jpg";